var _rect, _rect2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 24.5,
    height: 24.5,
    rx: 4.25,
    fill: "#FFF8E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 24.5,
    height: 24.5,
    rx: 4.25,
    stroke: "#D9A62E",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 18L16 13L11 8",
    stroke: "url(#paint0_linear_1158_13511)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18L9 13L4 8",
    stroke: "url(#paint1_linear_1158_13511)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9004 18L22.9004 13L17.9004 8",
    stroke: "url(#paint2_linear_1158_13511)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1158_13511",
    x1: 13.5,
    y1: 8,
    x2: 13.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1158_13511",
    x1: 6.5,
    y1: 8,
    x2: 6.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1158_13511",
    x1: 20.4004,
    y1: 8,
    x2: 20.4004,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandButton);
export default __webpack_public_path__ + "static/media/expand_button.5a62743ffd2f44051aa9369b72768fbe.svg";
export { ForwardRef as ReactComponent };